export default __webpack_public_path__ + "static/media/gatter.5dd9ba27.png";